import React from 'react';
import './App.css';
import { Box, Button, Container, Divider, Grid, Stack, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown'

function Section(props: {
  image: string,
  markdown: string,
  reverse?: boolean
}) {
  return (
    <Grid container spacing={5}>
      <Grid size={{ sm: 12, md: 6 }} order={{ sm: 1, md: props.reverse ? 2 : 1 }}>
        <img src={props.image} width="100%" height="100%" style={{ aspectRatio: 2 / 1, overflow: 'clip', objectFit: 'cover' }} />
      </Grid>
      <Grid size={{ sm: 12, md: 6 }} order={{ sm: 2, md: props.reverse ? 1 : 2 }} display="flex" flexDirection="column">
        <ReactMarkdown children={props.markdown} />
      </Grid>
    </Grid>
  )
}

function App() {
  const bgColor = 'rgb(22, 22, 22)';

  const sections = [
    {
      image: '/sections/平台介面圖.png',
      markdown: `
### Panoramic Med-Data and FL-AI Platform
資料管理與ＡＩ訓練平台，帶給使用者完整且智慧化的體驗

Efficient, Intelligent interface for Multi-modal data management
- 全域醫學資訊覆蓋 (Multi-formats Coverage)
- 去識別化資料工具 (Data Anonymization Tool)
- 內建資料標註工具 (Annotation/Labeling tool)
- 聯邦式學習AI工具 (Federated Learning AI tool)
      `,
    },
    {
      image: '/sections/截圖 2024-12-04 下午4.45.08.png',
      markdown: `
### ST Research Services
醫學演算法開發服務，將您的想法轉換成實際成果與文章

Transforming Your Ideas into Published Journal Articles
- 完整一條龍開發服務  (Completed Workflow)
- 經驗豐富的研發團隊 (Experienced Team)
- 多樣化模型開發選項 (Versatile Capabilities)
      `,
    },
    {
      image: '/sections/_fd8e9dd1-4863-4c11-b702-4b0462e5f1a7.jpeg',
      markdown: `
### Medical Information System Development
客製化醫療資訊系統開發，符合新潮流與法規需求

Customized Medical Information System for Next-Gen Regulation
- 掛號叫號管理系統 (Appointment management)
- 虛擬醫事人員系統 (Healthcare Certification Authority)
- FHIR/HL7資訊系統 (FHIR/HL7 Platform and APP)
- 患者個人資訊介面 (Personalize Patient Frontend)
      `,
    },
  ];

  const openSendEmail = () => {
    window.open(`mailto:jarvislin@stmedical.tw`)
  }

  return (
    <Stack sx={{ alignItems: "center", width: "100%" }}>
      <Box paddingX={5} sx={{ paddingY: { sx: 0, md: 5 } }}>
        <Box sx={{ maxWidth: 600 }}>
          <img src="/banner.png" width="100%" />
        </Box>
      </Box>
      <Stack sx={{ backgroundColor: bgColor, width: "100%" }}>
        <Container maxWidth="lg">
          <Stack paddingY={5} gap={3}>
            <Stack marginBottom={3} width="100%" sx={{ alignItems: "center" }}>
              <Typography fontSize={32} fontWeight={400} className='section-span' color='rgb(247, 247, 247)'>
                Solutions
              </Typography>
              <Divider sx={{ width: 50, borderBottomWidth: 2, borderBottomColor: 'rgb(42, 42, 42)', marginTop: 3 }} />
            </Stack>
            {
              sections.map((section, idx) => (
                <Section key={`sec_${idx}`} {...section} reverse={idx % 2 == 1} />
              ))
            }
          </Stack>
        </Container>
      </Stack>
      <Container maxWidth="lg">
        <Grid container>
          <Grid size={{ sm: 12, md: 6 }}>
            <Stack padding={5} spacing={3} sx={{ alignItems: { sm: "center", md: "flex-start" } }}>
              <Typography variant='h4' sx={{ color: 'rgb(111, 111, 111)' }}>Contact us</Typography>
              <Divider sx={{ width: 50, borderBottomWidth: 2, borderBottomColor: 'rgb(218, 218, 218)' }} />
              <Typography variant='h6'>Experience a better Medical Solution</Typography>
              <Typography variant='h6'>ST Medical Technology INC.</Typography>
              <Typography>台灣新竹市東區力行一路1號1B5-2</Typography>
              <Typography>jarvislin@stmedical.tw</Typography>
              <Button variant="contained" size="large" color="info" onClick={openSendEmail}>歡迎來信！</Button>
            </Stack>
          </Grid>
          <Grid size={{ sm: 12, md: 6 }} width="100%">
            <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3622.6591629928907!2d121.01433817609367!3d24.772872698755364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1z5Y-w54Gj5paw56u55biC5p2x5Y2A5Yqb6KGM5LiA6LevMeiZnzFCNS0y!5e0!3m2!1szh-TW!2stw!4v1746444734154!5m2!1szh-TW!2stw" width="100%" height="450" style={{ border: 0 }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
          </Grid>
        </Grid>
      </Container>
      <Stack sx={{ backgroundColor: bgColor, width: "100%" }}>
        <Container maxWidth="lg" style={{ padding: 40 }}>
          <p>Copyright © 2024 ST Medical 聖得醫學科技 — 保留所有權利。</p>
        </Container>
      </Stack>
    </Stack>
  );
}

export default App;
